/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Množství na jednotku`
};

const da_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Mængde pr. produkt`
};

const de_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Menge pro Produkt`
};

const en_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Quantity per product`
};

const es_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Cantidad por producto`
};

const fr_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Quantité du produit`
};

const hu_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Termékenkénti Mennyiség`
};

const it_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Quantità per prodotto`
};

const nl_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Hoeveelheid per product`
};

const pl_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Ilość na produkt`
};

const pt_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Quantidade por produto`
};

const sv_attributes_quantity_per_unit = /** @type {(inputs: {}) => string} */ () => {
	return `Antal per produkt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_quantity_per_unit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_quantity_per_unit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_quantity_per_unit", locale)
	if (locale === "cs") return cs_attributes_quantity_per_unit(inputs)
	if (locale === "da") return da_attributes_quantity_per_unit(inputs)
	if (locale === "de") return de_attributes_quantity_per_unit(inputs)
	if (locale === "en") return en_attributes_quantity_per_unit(inputs)
	if (locale === "es") return es_attributes_quantity_per_unit(inputs)
	if (locale === "fr") return fr_attributes_quantity_per_unit(inputs)
	if (locale === "hu") return hu_attributes_quantity_per_unit(inputs)
	if (locale === "it") return it_attributes_quantity_per_unit(inputs)
	if (locale === "nl") return nl_attributes_quantity_per_unit(inputs)
	if (locale === "pl") return pl_attributes_quantity_per_unit(inputs)
	if (locale === "pt") return pt_attributes_quantity_per_unit(inputs)
	return sv_attributes_quantity_per_unit(inputs)
};
export { attributes_quantity_per_unit as "attributes.quantity_per_unit" }